// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from 'app/components/CRUD/ViewEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
  getCurrentLanguageCode,
} from 'app/configuration/configuration-api';

const ViewFareMediaIssuerOrganization: React.FC = () => {
  const isEnglish = getCurrentLanguageCode() === 'en-us';

  return (
    <ViewEntity
      pageTitle="FareMediaIssuerOrganizationInfo"
      fetchApiUrl={CONFIG_PATHS.fareMediaIssuerOrganisationById}
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        {
          name: 'en_issuer_name',
          labelKey: 'FareMediaIssuer',
          type: 'custom',
          render: data =>
            (isEnglish ? data.en_issuer_name : data.ar_issuer_name) || '-',
        },
        {
          name: 'org_en_name',
          labelKey: 'Organisation',
          type: 'custom',
          render: data => (isEnglish ? data.org_en_name : data.org_ar_name) || '-',
        },
        {
          // Why delete and re-pointing may both be refused on this row.
          name: 'fare_media_count',
          labelKey: 'IssuedFareMedia',
          type: 'custom',
          render: data =>
            data.fare_media_count === undefined ? '-' : data.fare_media_count,
        },
        { name: 'created_at', labelKey: 'CreatedAt', type: 'date' },
        { name: 'updated_at', labelKey: 'UpdatedAt', type: 'date' },
      ]}
      editUrl={`${CONFIG_ROUTES.fareMediaIssuerOrganisations}/:id/edit`}
      deleteApiUrl={CONFIG_PATHS.fareMediaIssuerOrganisationById}
      deleteApiMethod="DELETE"
      backUrl={CONFIG_ROUTES.fareMediaIssuerOrganisations}
      backButtonLabel="Back"
      buildTitle={data => {
        const issuer = isEnglish ? data.en_issuer_name : data.ar_issuer_name;
        const org = isEnglish ? data.org_en_name : data.org_ar_name;
        return `${issuer || '-'} — ${org || '-'}`;
      }}
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        const en = currentLanguageCode === 'en-us';
        const issuer = en ? data.en_issuer_name : data.ar_issuer_name;
        const org = en ? data.org_en_name : data.org_ar_name;
        return `${intl.formatMessage({
          id: 'AreYouSureDeleteFareMediaIssuerOrganization',
        })} ${issuer || '-'} — ${org || '-'}?`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="FareMediaIssuersOrganisations"
      permissionSystem="masterConfig"
    />
  );
};

export default ViewFareMediaIssuerOrganization;
